import { WarningIcon } from "./icons";
import { Notice } from "./Notice";

interface AccountNotFoundNoticeProps {
  /** The signed-in email, shown so an admin can spot a mismatch. Null when unknown. */
  readonly email?: string | null;
}

/**
 * Full-pane "this account is not set up" state. Shown when the Studio settings
 * endpoint returns 404 — the signed-in user (or their email domain) does not
 * exist on the Console Users page in AiVA Studio. It replaces the entire
 * functional surface (Chat / Actions / Approvals / Modules) instead of leaving
 * the add-in showing an ambiguous "Disconnected" status with a chat that only
 * fails on send. Only an admin adding the account in Studio restores it.
 */
export function AccountNotFoundNotice({
  email,
}: Readonly<AccountNotFoundNoticeProps>) {
  const subject = email ? `${email} does not exist` : "This account does not exist";
  return (
    <Notice
      icon={<WarningIcon />}
      title="Account not found"
      message={`${subject} in AiVA Studio. Contact an administrator to have it added to the Console Users page in AiVA Studio.`}
    />
  );
}
